import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';

class ErrorMessage extends PureComponent {
  static propTypes = {
    id: PropTypes.string,
    error: PropTypes.shape({
      path: PropTypes.string,
      type: PropTypes.string,
    }),
    formatError: PropTypes.func,
    className: PropTypes.string,
  };

  static defaultProps = {
    formatError: (msg) => msg,
    className: '',
  };

  render() {
    const { id, error, formatError, className } = this.props;

    if (error && error.path) {
      return (
        <div id={id} className={`${className} ${styles.hasError}`}>
          <div className={styles.helpBlock}>{formatError(`${error.path}.${error.type}.error`)}</div>
        </div>
      );
    }

    return null;
  }
}

export default ErrorMessage;
